enum OPD_VISIT_TYPE {
  TF = "TF",
  FLU = "FLU"
}

export default OPD_VISIT_TYPE;
